import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  currentPage: 1,
  currentFilter: "all",
  currentPageSize: 20,
  sortBy: "",
  sortOrder: "",
  search: "",
  showAddServiceModal: false,
  clearSelection: false,
  selectedItem: "",
  itemData: [],
  isEdit: false,
};

const serviceSlice = createSlice({
  name: "service",
  initialState,
  reducers: {
    updateConfig: (state, action) => {
      action.payload(state);
    },
  },
});

export const { updateConfig } = serviceSlice.actions;

export default serviceSlice.reducer;
